/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * All of the possible `ChipType*`'s.
 */
export type ChipType = ChipTypeNavigation | ChipTypeSelection | ChipTypeRemovable;

/**
 * The Chip navigation type.
 */
export type ChipTypeNavigation = typeof CHIP_TYPE_NAVIGATION;

/**
 * The Chip selection type.
 */
export type ChipTypeSelection = typeof CHIP_TYPE_SELECTION;

/**
 * The Chip removable type.
 */
export type ChipTypeRemovable = typeof CHIP_TYPE_REMOVABLE;

/**
 * The Chip navigation constant.
 */
export const CHIP_TYPE_NAVIGATION = `navigation`;

/**
 * The Chip selection constant.
 */
export const CHIP_TYPE_SELECTION = `selection`;

/**
 * The Chip removable constant.
 */
export const CHIP_TYPE_REMOVABLE = `removable`;
